import { useQuery } from '@tanstack/react-query';
import { getHeatmapData, type HeatmapData } from '../api/client';

interface UseHeatmapParams {
  url: string;
  type: string;
  dateRange?: string;
  device?: string;
}

export function useHeatmap(params: UseHeatmapParams) {
  return useQuery<HeatmapData, Error>({
    queryKey: ['heatmap', params],
    queryFn: () => getHeatmapData(params),
    enabled: !!params.url,
  });
}
